import Bugsnag from "@vromo/analytics/bugsnag"
import { UserAccessPosition, UserAccessTypes } from "."


/** returns the User access type for a given UserPosition ID */
export const userAccessByPosition = (id: number): UserAccessTypes => {
    const [userAccessByPosition] = Object.entries(UserAccessPosition).find(([, value]) => value === id) || []
    if (!userAccessByPosition)
        throw new Error(`User Access type not found for position id '${id}'`)
    return userAccessByPosition as UserAccessTypes
}

type LeaveQueryBreadCrumbInput = {
    msg?: string,
    data: any,
    type: 'response' | 'request',
    path: string,
    protocol: 'post' | 'patch' | 'delete' | 'get'
}

/** leave a breadcrumb on bugsnag. Used mostly for tracking http request details */
export const leaveQueryBreadCrumb = ({ msg, data, type, path, protocol }: LeaveQueryBreadCrumbInput): void => {
    Bugsnag.leaveBreadcrumb(`${protocol} api query ${type} data`, {
        packet: JSON.stringify(data),
        path,
        msg
    });
}